import React, { useCallback, useRef } from 'react';
import { IStaticElement } from 'shared/offerCalculator/types/calculator';
import { UIHeading4 } from '@cian/ui-kit';

import { IconActionChevronDown16, IconActionChevronUp16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './styles.css';
import { useDispatch, useSelector } from 'react-redux';
import { selectDisplayAllFilters } from 'shared/offerCalculator/selectors';
import { setDisplayAllFilters } from 'shared/offerCalculator/redux';
import { debouncedClickMoreFiltersAnalyticsHandler } from 'shared/offerCalculator/utils/debouncedEventHandlers';

export const MoreFiltersButton: React.FC<IStaticElement> = () => {
  const $btnRef = useRef<HTMLButtonElement>(null);
  const dispatch = useDispatch();
  const isAllFiltersVisible = useSelector(selectDisplayAllFilters);
  const analyticsMoreFiltersClickHandler = debouncedClickMoreFiltersAnalyticsHandler($btnRef?.current);
  const handler = useCallback(() => {
    dispatch(setDisplayAllFilters(!isAllFiltersVisible));
    analyticsMoreFiltersClickHandler();
  }, [dispatch, analyticsMoreFiltersClickHandler, isAllFiltersVisible]);

  return (
    <button ref={$btnRef} className={styles.root} type="button" onClick={handler} data-testid="form-feature-button">
      <UIHeading4 color="text-main-default">Ещё фильтры</UIHeading4>
      {isAllFiltersVisible ? (
        <IconActionChevronUp16 color="icon-main-default" />
      ) : (
        <IconActionChevronDown16 color="icon-main-default" />
      )}
    </button>
  );
};
